import * as server from "@/utils/http"

export const _pages = params => server.get("/result-word/pages", params);

export const _get = params => server.get("/result-word/get", params);

export const _save = params => server.post(params.id ? "/result-word/update" : "/result-word/save", params);

export const _updateStatus = params => server.get("/result-word/updateStatus", params);

export const _delete = params => server.get("/result-word/delete", params);

export const _baseData = params => server.get("/result-word/baseData", params);

